import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { MetricsSection } from './components/MetricsSection';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TomosSection } from './components/TomosSection';
import { IncludesSection } from './components/IncludesSection';
import { BonusSection } from './components/BonusSection';
import { OfferSection } from './components/OfferSection';
import { CostSection } from './components/CostSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { WhatsAppTestimonials } from './components/WhatsAppTestimonials';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-ink-900 font-sans" data-id="element-0" data-mp="23v2td3l0915e">
      <Hero data-id="element-1" data-mp="3iiweam7rne26" />
      <main data-id="element-2" data-mp="3ij65gd4jrr9g">
        <MetricsSection data-id="element-3" data-mp="3ijpcgysnsv8p" />
        <Testimonials data-id="element-4" data-mp="3ii4ppvcl6gle" />
        <PainPoints data-id="element-5" data-mp="3ml1397n9rmih" />
        <TomosSection data-id="element-6" data-mp="3mkhnnxl3da7m" />
        <IncludesSection data-id="element-7" data-mp="3mjq27fl7ksv2" />
        <BonusSection data-id="element-8" data-mp="3rc9em985thya" />
        <OfferSection data-id="element-9" data-mp="3rbrbcsn2y3gv" />
        <CostSection data-id="element-10" data-mp="3rdki07xp0nov" />
        <GuaranteeSection data-id="element-11" data-mp="3rd19tixuhdo1" />
        <FaqSection data-id="element-12" data-mp="5yj0slx59ec" />
        <WhatsAppTestimonials data-id="element-13" data-mp="6hq1ea16ddl" />
        <FinalCta data-id="element-14" data-mp="4n7u7q58zd7" />
      </main>
      <Footer data-id="element-15" data-mp="7suzhf7pr6a" />
    </div>;
}